export interface TimelineEvent {
  label: string
  sublabel?: string
  description: string
}

interface TimelineItemProps {
  label: string
  sublabel?: string
  description: string
  showConnector: boolean
  isLast: boolean
}

function TimelineItem ({ label, sublabel, description, showConnector, isLast }: TimelineItemProps) {
  return (
    <div className={`flex gap-2 ${isLast ? '' : 'mb-10'}`}>
      {/* Column 1: Label (right-aligned, with optional sublabel below) */}
      <div className='w-16 flex-shrink-0 text-right'>
        <p className='body-sm font-medium text-gray-800'>{label}</p>
        {sublabel && (
          <p className='caption text-gray-500'>{sublabel}</p>
        )}
      </div>

      {/* Column 2: Dot and vertical connector line */}
      <div className='flex flex-col items-center flex-shrink-0 w-1.5'>
        {/* Dot - aligned with first line of text */}
        <svg
          width='6'
          height='6'
          viewBox='0 0 6 6'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='mt-1.5 flex-shrink-0'
        >
          <circle cx='3' cy='3' r='3' fill='#9C3BFF' />
        </svg>
        {/* Vertical line connecting to next dot */}
        {showConnector && (
          <div className='w-px flex-1 bg-purple-300 mt-1.5 -mb-10' />
        )}
      </div>

      {/* Column 3: Text box - pulled up so text content aligns with label/dot */}
      <div className='flex-1 bg-white border border-gray-200 rounded-xl p-3 -mt-3'>
        <p className='body-sm text-gray-600'>{description}</p>
      </div>
    </div>
  )
}

export interface TimelineProps {
  title?: string
  subtitle?: string
  events: TimelineEvent[]
}

export function Timeline ({ title = 'Expected timeline', subtitle, events }: TimelineProps) {
  return (
    <div>
      <p className={`body-bold ${subtitle ? 'mb-2' : 'mb-6'}`}>{title}</p>
      {subtitle && <p className='text-sm text-gray-500 mb-6'>{subtitle}</p>}

      <div>
        {events.map((event, index) => (
          <TimelineItem
            key={`${event.label}-${index}`}
            label={event.label}
            sublabel={event.sublabel}
            description={event.description}
            showConnector={index < events.length - 1}
            isLast={index === events.length - 1}
          />
        ))}
      </div>
    </div>
  )
}
